module.exports = __webpack_public_path__ + "img/MobilePenetration.5db7317f.jpg";